module.exports = __webpack_public_path__ + "img/rules_16.690245c7.png";